


























































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import NumberValue from '@/tasks/components/NumberValue.vue';
import {defineComponent} from '@vue/composition-api';

export default defineComponent({
  name: 'uOttawa1321Lab4Question2',
  components: {
    NumberValue,
    StembleLatex,
    CalculationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        maxYield: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      calculations: [] as File[],
    };
  },
  computed: {
    sol25(): number {
      return (this as any).taskState.getValueBySymbol('sol25').content;
    },
    sol108(): number {
      return (this as any).taskState.getValueBySymbol('sol108').content;
    },
    attachments(): File[] {
      return [...this.calculations];
    },
  },
});
